import React from 'react';
import { ArrowRight } from 'lucide-react';
import { HERO_IMAGE } from '../mock';

export default function Hero() {
  return (
    <section id="top" className="relative w-full">
      {/* Logo intro block */}
      <div className="relative w-full bg-[color:var(--sd-bg)] py-24 md:py-32 flex flex-col items-center justify-center sd-grid-bg">
        <div className="relative inline-block">
          {/* Bracket marks */}
          <span className="absolute -top-6 -left-8 text-[color:var(--sd-cyan)] text-3xl md:text-4xl">┌</span>
          <span className="absolute -top-6 -right-8 text-[color:var(--sd-cyan)] text-3xl md:text-4xl">┐</span>
          <div className="font-display font-black text-white text-3xl md:text-5xl tracking-widest px-6">
            SQUARE
          </div>
          <div className="font-display font-black text-[color:var(--sd-cyan)] text-5xl md:text-8xl tracking-wider px-2 sd-glow">
            DARTS
          </div>
        </div>
        <div className="mt-6 text-xs md:text-sm tracking-[0.35em] text-[color:var(--sd-muted)] font-mono">
          <span className="sd-caret">BRASIL // ONLINE DARTS TECHNOLOGY</span>
        </div>
      </div>

      {/* Slant divider */}
      <div className="h-8 bg-gradient-to-b from-[#050608] to-[#0b1517]" style={{ clipPath: 'polygon(0 0, 100% 55%, 100% 100%, 0 100%)' }} />

      {/* Tech hero with soft-tip dartboard */}
      <div className="relative w-full overflow-hidden bg-[#050608]" style={{ minHeight: '640px' }}>
        {/* Radial glow behind dartboard */}
        <div
          className="absolute right-[-8%] top-1/2 -translate-y-1/2 w-[70%] h-[120%] pointer-events-none"
          style={{
            background:
              'radial-gradient(circle at center, rgba(34,230,230,0.25) 0%, rgba(34,230,230,0.08) 30%, rgba(5,6,8,0) 60%)',
          }}
        />
        <div className="absolute inset-0 sd-grid-bg opacity-40 pointer-events-none" />

        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="max-w-xl">
            <div className="text-[color:var(--sd-cyan)] text-xs tracking-[0.4em] mb-4 font-mono">
              // SQUARE DARTS BRASIL
            </div>
            <h1 className="font-display font-black text-white text-4xl md:text-6xl lg:text-7xl leading-[1.05] tracking-wide">
              TECNOLOGIA<br />DE JOGO<br />
              <span className="text-[color:var(--sd-cyan)] sd-glow">ONLINE</span>
            </h1>
            <p className="mt-8 text-[color:var(--sd-text)]/80 max-w-lg leading-relaxed font-mono">
              Os Dardos profissionais estão a chegar. Oferecemos a solução de
              ponta para bares e pubs que buscam performance e tecnologia.
            </p>
            <div className="mt-10">
              <a href="#categorias" className="sd-btn">
                VER PRODUTOS <ArrowRight size={16} />
              </a>
            </div>
          </div>

          {/* Soft-tip dartboard visual */}
          <div className="relative flex items-center justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px] aspect-square">
              {/* Halo blur behind */}
              <div className="sd-neon-halo absolute -inset-10" />
              {/* Dashed rotating rings */}
              <div className="sd-neon-ring sd-neon-dash -inset-2" />
              <div className="sd-neon-ring sd-neon-dash-rev inset-4" />
              {/* Solid neon rings */}
              <div className="sd-neon-ring sd-neon-mid inset-0" />
              <div className="sd-neon-ring sd-neon-outer inset-2" />

              <img
                src={HERO_IMAGE}
                alt="Alvo eletrónico soft-tip"
                className="relative z-10 w-full h-full"
                style={{
                  objectFit: 'contain',
                  transform: 'scale(1.02)',
                  clipPath: 'circle(46% at 50% 50%)',
                  filter:
                    'drop-shadow(0 0 20px rgba(34,230,230,0.6)) drop-shadow(0 0 40px rgba(34,180,255,0.4))',
                }}
              />

              {/* Corner brackets */}
              <span className="absolute -top-2 -left-2 w-8 h-8 border-l-2 border-t-2 border-[color:var(--sd-cyan)] shadow-[0_0_12px_var(--sd-cyan)]" />
              <span className="absolute -top-2 -right-2 w-8 h-8 border-r-2 border-t-2 border-[color:var(--sd-cyan)] shadow-[0_0_12px_var(--sd-cyan)]" />
              <span className="absolute -bottom-2 -left-2 w-8 h-8 border-l-2 border-b-2 border-[color:var(--sd-cyan)] shadow-[0_0_12px_var(--sd-cyan)]" />
              <span className="absolute -bottom-2 -right-2 w-8 h-8 border-r-2 border-b-2 border-[color:var(--sd-cyan)] shadow-[0_0_12px_var(--sd-cyan)]" />
            </div>
          </div>
        </div>

        {/* Corner HUD marks */}
        <div className="absolute top-6 left-6 text-[10px] tracking-[0.3em] text-[color:var(--sd-cyan)]/70 font-mono">
          <div>[ CH.01 // NODE-BR ]</div>
          <div className="opacity-70">LAT -14.235 // LON -51.925</div>
        </div>
        <div className="absolute bottom-6 right-6 text-[10px] tracking-[0.3em] text-[color:var(--sd-cyan)]/70 font-mono text-right">
          <div>SIGNAL // █████░</div>
          <div className="opacity-70">v.2027.03</div>
        </div>
      </div>
    </section>
  );
}
